<template>
    <GarudaContainer>
        <template slot="garuda:content">
            <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
                <div class="boxShadow setBorderRadius heig-frame-equipment-group">
                    <b-row no-gutters>
                        <b-col md="12" class="heig-frame-child">
                            <gofix-card class="mb-0 heig-frame-child" fullContent>
                                <gofix-table :settings="tableConfig"
                                    :table-items="tableItems"
                                    @load-items="getTableData"
                                    @row-click="clickToRowItem"
                                    @export="exportItems"
                                    ref="gofixTable">
                                    <template slot="gofix_table:job_number" slot-scope="row">
                                        <router-link target="_blank" class="text-dark" :to="`/v2/job-list/${row.item.id}`">
                                            <span class="text-decoration-underline">{{  row.item.job_number  }}</span>
                                        </router-link>
                                    </template>
                                </gofix-table>
                            </gofix-card>
                            <ModalDocuments :inspection_id="modals.documents.inspection_id" v-model="modals.documents.open" />
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.downloading.title" hide-footer :centered="true" v-model="modals.downloading.open" hide-header-close>
                <b-progress :max="100" height="3rem" show-progress animated>
                <b-progress-bar :value="100">
                    <span class="font-size-16">Loading</span>
                </b-progress-bar>
                </b-progress>
            </b-modal>
        </template>
    </GarudaContainer>  
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import GarudaContainer from '../default-view.vue'
    import ModalDocuments from './ModalDocuments.vue'
    export default {
        name: 'inspection-jobs',
        components: {
            GarudaContainer,
            ModalDocuments
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['garuda_inspections']));
            let dataSelect = {
                job_status: {
                    value: [
                        {value: 'Planned', text: 'Planned'},
                        {value: 'Due', text: 'Due'},
                        {value: 'Started', text: 'Started'},
                        {value: 'Completed', text: 'Completed'},
                        {value: 'Verified', text: 'Verified'},
                        {value: 'Endorsed', text: 'Endorsed'},
                        {value: 'Cancelled', text: 'Cancelled'},
                        {value: 'Expired', text: 'Expired'},
                        {value: 'End', text: 'End'},
                        {value: 'Inactive', text: 'Inactive'},
                    ],
                    value_field: 'value',
                    text_field: 'text'
                }
            }
            return {
                tableConfig:{
                    name: 'garuda-inspection-jobs',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    dataSelect: dataSelect,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                        // {
                        //     key: 'actions',
                        //     label: '',
                        //     width: 50,
                        //     thStyle: "width:50px",
                        // },
                        {
                            key: 'inspection_id',
                            label: 'Inspection ID',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'facility_id',
                            label: 'Facility ID',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'job_number',
                            label: 'Job number',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'root_path',
                            label: 'Root Path',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        },
                        {
                            key: 'job_status',
                            label: 'Job status',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:150px",
                            sorting: true,
                            with:150,
                        }
                    ],
                },
                tableItems: [],
                modals: {
                    documents: {
                        open: false,
                        inspection_id: null
                    },
                    downloading : {
                        open: false,
                        title: 'Downloading',
                    },
                },
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                let contract = localStorage.getItem("ClientContractID")
                if(
                    (contract !== undefined && contract !== 'null' && contract !== '' && contract !== null && this.ClientContractID != null) &&
                    (
                        (tableRequest.filter.hasOwnProperty('contract_id') && ((tableRequest.filter.contract_id.hasOwnProperty('value') && !tableRequest.filter.contract_id.value) || !tableRequest.filter.contract_id))
                        || (tableRequest.filter.hasOwnProperty('client_contract_id') && ((tableRequest.filter.client_contract_id.hasOwnProperty('value') && !tableRequest.filter.client_contract_id.value) || !tableRequest.filter.client_contract_id))
                        || (tableRequest.filter.hasOwnProperty('contract_term_id') && ((tableRequest.filter.contract_term_id.hasOwnProperty('value') && !tableRequest.filter.contract_term_id.value) || !tableRequest.filter.contract_term_id))
                    )
                ) {
                    return
                }
                await this.$store.dispatch("GarudaController/getGarudaInspections", tableRequest)
                    .then(response => {                        
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load garuda inspections jobs", "danger");
                        reject();
                    });
            },
            async clickToRowItem(item){
                if(!item || !item.inspection_id) return
                this.modals.documents.open = true
                this.modals.documents.inspection_id = item.inspection_id
            },
            exportItems(tableRequest){
                this.modals.downloading.open = true;
                this.$store.dispatch("GarudaController/exportInspections", tableRequest)
                .then(response => {
                    if(response.data.size === 0) {
                        this.$alertNotification("Blank export", "warning");
                        return;
                    }

                    let nameFile = 'ExportInspections.csv';
                    if(response.headers["content-disposition"]) {
                        let arrTemp = response.headers["content-disposition"].split("filename=");
                        if(arrTemp[1]) {
                            nameFile = arrTemp[1].replaceAll('"', "");
                        }
                    }
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile);
                    document.body.appendChild(link);
                    link.click();

                    this.modals.downloading.open = false;
                }).catch(err => {
                    this.modals.downloading.open = false;
                });
            },
        }
    }
</script>
